import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../_shared/shared.module';
import { DriveTestPageComponent } from '../pages/drive-test-page/drive-test-page.component';
import { OpendataPageComponent } from '../pages/opendata-page/opendata-page.component';
import { IndicatorsPageComponent } from '../pages/indicators/indicators-page.component';
import { IndicatorsValuesComponent } from '../pages/indicators/indicators-values/indicators-values.component';
import { IndicatorChartComponent } from '../pages/indicators/indicators-chart/indicator-chart.component';
import { IndicatorsDetailsComponent } from '../pages/indicators/indicators-details/indicators-details.component';
import { IndicatorButtonsComponent } from '../pages/indicators/indicator-buttons/indicator-buttons.component';
import { ChipsAutocompleteComponent } from '../pages/indicators/chips-autocomplete/chips-autocomplete.component';
import { SaveInputValueDirective } from '../pages/indicators/save-input-value.directive';
import { SocialButtonsComponent } from '../pages/indicators/social-buttons/social-buttons.component';

const routes: Routes = [
  { path: 'opendata', component: OpendataPageComponent },
  { path: 'indicators', component: IndicatorsPageComponent },
  { path: 'userexperience', component: DriveTestPageComponent },
];

@NgModule({
  declarations: [
    DriveTestPageComponent,
    OpendataPageComponent,
    IndicatorsPageComponent,
    IndicatorsValuesComponent,
    IndicatorChartComponent,
    IndicatorsDetailsComponent,
    IndicatorButtonsComponent,
    ChipsAutocompleteComponent,
    SaveInputValueDirective,
    SocialButtonsComponent,
  ],
  imports: [SharedModule, RouterModule.forChild(routes)],
})
export class DataModule {}